import * as React from 'react';
import { Layout, Row, Col, Card, Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { KeyValueDisplay } from '../key_value_display/KeyValueDisplay';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	capitalize,
	currencyFormatter,
	joinList,
	joinListElements,
	optionalFilter,
} from '../../utils/DataFormatterUtils';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { fieldTechsRestCrudThunksForSupplier } from '../../thunks/field_techs_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import EditManageStockLocationsModal from './EditManageStockLocationsModal';
import EditAccessibleStockLocationsModal from './EditAccessibleStockLocationsModal';
import EditSupervisorsModal from './EditSupervisorsModal';
import HyperLink, { ENTITY_TYPE, HYPERLINK_VARIANT } from '../common/HyperLink';
import FieldTechAccessibleLocationsCard from './FieldTechAccessibleLocationsCard';
import FieldTechLocationsRoutingCard from './FieldTechLocationsRoutingCard';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import WorkOrderTable from '../WorkOrderTable';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';
import { UserName } from '../name_component/user/UserNameComponent';
import { formatContactEpaCertification } from '../../utils/RefrigerantUtils';
import { isRefrigerantTrackingEnabled } from '../../utils/FeatureFlagUtils';

const { Content } = Layout;

require('./FieldTechsDetailDetailsPage.less');

const FIELD_TECH_ASSOCIATED_OPEN_WORK_ORDERS_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_fieldTechAssociatedOpenWorkOrders';
const FIELD_TECH_ASSOCIATED_WORK_HISTORY_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_fieldTechAssociatedWorkHistory';

class FieldTechsDetailDetailsPage extends React.Component<any, any> {
	initialPaginationActiveWorkOrders: any = {
		current: 1,
		pageSize: 3,
		pageSizeOptions: ['3', '5', '10', '25', '50'],
	};
	initialPaginationWorkHistory: any = {
		current: 1,
		pageSize: 3,
		pageSizeOptions: ['3', '5', '10', '25', '50'],
	};
	constructor(props) {
		super(props);
		this.state = {
			displayMode: 'list',
			showEditSL: false,
			showEditAccessibleSL: false,
			showEditSupervisors: false,
		};
	}

	refreshFieldTech = () => {
		const { getFieldTech, match } = this.props;
		const fieldTechId = match.params.id;
		getFieldTech(fieldTechId);
	};

	hideEditManageStockLocations = () => this.setState({ showEditSL: false });

	editManageStockLocations = () => this.setState({ showEditSL: true });

	handleManageStockLocationSuccess = () => {
		this.hideEditManageStockLocations();
		this.refreshFieldTech();
	};

	// Each card below edits a single attribute via its own endpoint, then refreshes the field tech
	// so the newly-saved value renders. Managed stock locations keep their dedicated modal above.
	showEditAccessibleStockLocations = () => this.setState({ showEditAccessibleSL: true });
	hideEditAccessibleStockLocations = () => this.setState({ showEditAccessibleSL: false });
	handleAccessibleStockLocationsSuccess = () => {
		this.hideEditAccessibleStockLocations();
		this.refreshFieldTech();
	};

	showEditSupervisors = () => this.setState({ showEditSupervisors: true });
	hideEditSupervisors = () => this.setState({ showEditSupervisors: false });
	handleSupervisorsSuccess = () => {
		this.hideEditSupervisors();
		this.refreshFieldTech();
	};

	render() {
		const { fieldTech, fieldTechsFetching, history, currentUser } = this.props;

		const supervisors = nullSafeGetOrElse('inventorySupervisorContacts', fieldTech, []);
		const fieldTechDetails = {
			Role: nullSafeGet('role', fieldTech) ? capitalize(nullSafeGet('role', fieldTech)) : '--',
			'Hourly Rate': currencyFormatter()(nullSafeGet('hourlyRate', fieldTech)),
		};

		// Read off `supplierContact`, not off the field tech, because the 608 credential is a column on
		// the CONTACT record — the same record the refrigerant event's acceptance rule (a) resolves
		// `technicianEmail` to. This card is where a supervisor checks another tech's certification, so
		// it is what tells them why that tech's events are asking for a manually typed certification.
		//
		// One row for the pair, and dropped entirely when neither half is set — same reasoning as the
		// profile pages. Read-only HERE, but editable: the Edit Field Tech form carries both halves and
		// saves them onto this same contact row, as does the tech's own profile.
		const epaCertification = isRefrigerantTrackingEnabled()
			? formatContactEpaCertification(nullSafeGet('supplierContact', fieldTech))
			: null;

		const contactDetails = {
			Email: nullSafeGet('supplierContact.email', fieldTech),
			'Work Phone': optionalFilter(nullSafeGet('supplierContact.phoneWork', fieldTech)),
			'Mobile Phone': optionalFilter(nullSafeGet('supplierContact.phoneMobile', fieldTech)),
			Fax: optionalFilter(nullSafeGet('supplierContact.fax', fieldTech)),
			...(epaCertification ? { 'EPA Certification': epaCertification } : {}),
		};

		return (
			<Content className="fieldTechDetailDetailsPage" style={{ padding: '0 0.5em' }}>
				{fieldTechsFetching ? (
					<PageLoadingPlaceholder />
				) : (
					<div>
						<Row style={{ margin: '0 -0.5em' }} gutter={16}>
							<Col span={16}>
								<div className="rowSpacing">
									<Card title="Active Work Orders">
										<WorkOrderTable
											handleQueryParams={false}
											key={`active-work-orders-${nullSafeGet('email', fieldTech)}`}
											CustomHeader={() => <></>}
											preAppliedFilters={{
												[getWorkOrderArchivalKey(currentUser)]: false,
												isActive: true,
												fieldTechnicianEmail: nullSafeGet('email', fieldTech),
											}}
											tableStyle={{
												display: 'flex',
												flexDirection: 'column',
												cursor: 'pointer',
												userSelect: 'none',
												marginTop: '-10px',
												marginBottom: '-9px',
											}}
											initialPagination={{ current: 1, pageSize: 3 }}
											targetCollectionName={
												FIELD_TECH_ASSOCIATED_OPEN_WORK_ORDERS_TARGET_COLLECTION
											}
											renderEmptyState={() => (
												<EmptyState
													graphic={
														<img
															alt="No open active work orders found."
															style={{ marginBottom: 8 }}
															src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
														/>
													}
													headline={'No open active work orders found.'}
													body={
														<div style={{ textAlign: 'center' }}>
															<div style={{ maxWidth: 440, marginBottom: 16 }}></div>
														</div>
													}
												/>
											)}
											backText="Back"
											openMoreInDefault
											ignoreRefreshCounts
										/>
									</Card>
								</div>

								<div className="rowSpacing">
									<Card title="Work History">
										<WorkOrderTable
											handleQueryParams={false}
											key={`work-history-${nullSafeGet('email', fieldTech)}`}
											CustomHeader={() => <></>}
											preAppliedFilters={{
												[getWorkOrderArchivalKey(currentUser)]: false,
												isActive: false,
												fieldTechnicianEmail: nullSafeGet('email', fieldTech),
											}}
											tableStyle={{
												display: 'flex',
												flexDirection: 'column',
												cursor: 'pointer',
												userSelect: 'none',

												marginTop: '-10px',
												marginBottom: '-9px',
											}}
											initialPagination={{ current: 1, pageSize: 3 }}
											targetCollectionName={FIELD_TECH_ASSOCIATED_WORK_HISTORY_TARGET_COLLECTION}
											renderEmptyState={() => (
												<EmptyState
													graphic={
														<img
															alt="No open work orders found."
															style={{ marginBottom: 8 }}
															src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
														/>
													}
													headline={'No open work orders found.'}
													body={
														<div style={{ textAlign: 'center' }}>
															<div style={{ maxWidth: 440, marginBottom: 16 }}></div>
														</div>
													}
												/>
											)}
											backText="Back"
											ignoreRefreshCounts
										/>
									</Card>
								</div>
							</Col>
							<Col span={8}>
								<FieldTechAccessibleLocationsCard
									fieldTech={fieldTech}
									onLocationsUpdated={this.refreshFieldTech}
								/>
								<FieldTechLocationsRoutingCard
									fieldTech={fieldTech}
									onFieldTechUpdated={this.refreshFieldTech}
								/>
								<div className="rowSpacing">
									<Card
										title="Accessible Stock Locations"
										extra={
											<AccessPermissionChecker
												name={PERMISSION_NAMES.ASSIGN_ACCESS_TO_STOCK_LOCATIONS}
												permissionDeniedContent={null}
											>
												<Button type="link" onClick={this.showEditAccessibleStockLocations}>
													Edit
												</Button>
											</AccessPermissionChecker>
										}
									>
										{nullSafeGet('hasAccessToAllStockLocations', fieldTech) ? (
											'All stock locations'
										) : nullSafeGet('accessibleStockLocations.0', fieldTech) ? (
											<div>
												{fieldTech.accessibleStockLocations.map((sl) => (
													<HyperLink
														key={`sl-${sl.id}`}
														text={sl.name}
														entityType={ENTITY_TYPE.STOCK_LOCATION}
														entityId={sl.id}
														backLinkText={'Back to Field Tech Detail'}
														variant={HYPERLINK_VARIANT.SUBTLE}
													/>
												))}
											</div>
										) : (
											'No Stock Location Accessible'
										)}
									</Card>
								</div>
								<div className="rowSpacing">
									<Card
										title="Managed Stock Locations"
										extra={
											<AccessPermissionChecker
												name={PERMISSION_NAMES.ASSIGN_MANAGE_STOCK_LOCATIONS}
												permissionDeniedContent={null}
											>
												<Button type="link" onClick={this.editManageStockLocations}>
													Edit
												</Button>
											</AccessPermissionChecker>
										}
									>
										{nullSafeGet('canManageAllStockLocations', fieldTech) ? (
											'All accessible stock locations'
										) : nullSafeGet('managedStockLocations.0', fieldTech) ? (
											<div>
												{fieldTech.managedStockLocations.map((sl) => (
													<HyperLink
														key={`sl-${sl.id}`}
														text={sl.name}
														entityType={ENTITY_TYPE.STOCK_LOCATION}
														entityId={sl.id}
														backLinkText={'Back to Field Tech Detail'}
														variant={HYPERLINK_VARIANT.SUBTLE}
													/>
												))}
											</div>
										) : (
											'No Stock Location Managed'
										)}
									</Card>
								</div>
								<div className="rowSpacing">
									<Card
										title="Supervisors"
										extra={
											<AccessPermissionChecker
												name={PERMISSION_NAMES.ASSIGN_SUPERVISOR}
												permissionDeniedContent={null}
											>
												<Button type="link" onClick={this.showEditSupervisors}>
													Edit
												</Button>
											</AccessPermissionChecker>
										}
									>
										{supervisors.length > 0 ? (
											<div>
												{supervisors.map((contact, index) => (
													<span key={`supervisor-${nullSafeGet('email', contact)}`}>
														<UserName contact={contact} mode={'inline'} />
														{joinListElements(supervisors.length, index)}
													</span>
												))}
											</div>
										) : (
											'No Supervisors'
										)}
									</Card>
								</div>
								{fieldTech.notesOnTech ? (
									<div className="rowSpacing">
										<Card title="Field Tech Notes">
											<div
												className="richTextWrapper"
												dangerouslySetInnerHTML={{ __html: fieldTech.notesOnTech }}
											/>
										</Card>
									</div>
								) : null}
								<div className="rowSpacing">
									<Card title="Field Tech Details">
										<KeyValueDisplay keyValueStore={fieldTechDetails} />
									</Card>
								</div>
								<div className="rowSpacing">
									<Card title="Contact Info">
										<KeyValueDisplay keyValueStore={contactDetails} />
									</Card>
								</div>
							</Col>
						</Row>
					</div>
				)}
				{this.state.showEditSL && (
					<EditManageStockLocationsModal
						onCancel={this.hideEditManageStockLocations}
						onSuccess={this.handleManageStockLocationSuccess}
					/>
				)}
				{this.state.showEditAccessibleSL && (
					<EditAccessibleStockLocationsModal
						email={nullSafeGet('email', fieldTech)}
						hasAccessToAllStockLocations={!!nullSafeGet('hasAccessToAllStockLocations', fieldTech)}
						stockLocationIds={nullSafeGetOrElse('accessibleStockLocations', fieldTech, []).map(
							(sl) => sl.id
						)}
						onCancel={this.hideEditAccessibleStockLocations}
						onSuccess={this.handleAccessibleStockLocationsSuccess}
					/>
				)}
				{this.state.showEditSupervisors && (
					<EditSupervisorsModal
						email={nullSafeGet('email', fieldTech)}
						supervisorEmails={nullSafeGetOrElse('inventorySupervisorContacts', fieldTech, []).map(
							(contact) => contact.email
						)}
						onCancel={this.hideEditSupervisors}
						onSuccess={this.handleSupervisorsSuccess}
					/>
				)}
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,

	fieldTechsFetching: state.field_techs.fetching,
	fieldTech: state.field_techs.detail,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	getFieldTech: (id) => dispatch(fieldTechsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(FieldTechsDetailDetailsPage)
);
